import * as React from "react"
import {Box, Typography} from "@mui/material";
import {FlagsIconSeeker, ToggleButtonSeeker} from "@ui-seeker/core";

import {ActionButton} from "@components";
import {monitoringResultsReportFormIsOpen, monitoringResultsRefreshDataModalIsOpen} from "../@signals";


export default function MonitoringResultsTableToolbar({ countries, countrySelected, onChange=null }) {
	return <Box
		display="flex"
		alignItems="center"
		gap={2}
	>
		<ToggleButtonSeeker
			value={countrySelected}
			disabled={onChange === null}
			onChange={(_, newValue) => onChange(newValue)}
			tabs={countries.map(({ country, currency }) => ({
				label: <Box display="flex" alignItems="center" gap={.5}>
					<FlagsIconSeeker countryName={country} /> {country.toUpperCase()}
					<Typography> ({currency}) </Typography>
				</Box>,
				value: country
			}))}
		/>

		<ActionButton
			disabled={onChange === null}
			label="Create New Report"
			icon="pen-to-square"
			onClick={() => monitoringResultsReportFormIsOpen.value = true}
		/>

		<ActionButton
			disabled={onChange === null}
			label="Refresh Data Now"
			icon="arrows-rotate"
			onClick={() => monitoringResultsRefreshDataModalIsOpen.value = true}
		/>
	</Box>
}